export const REACT_COMPONENT_DATA = 'data-reactcomponent';
export const COMPONENT_TYPE = 'data-componenttype';

export enum ComponentType {
    Standard = 'standard',
    Lightweight = 'lightweight',
    App = 'app',
}

export const REPORT_CONTENT_SELECTOR = '[data-test-id="report-content"]';
